import { createApi } from "@reduxjs/toolkit/query/react";
import {
  baseQueryWithArgs,
  getQueryStringWithCreator,
} from "../../../utils/reduxHelper";
import {
  hideToastNotification,
  showToastNotification,
} from "../../../redux/redux";
import { store } from "../../../redux/redux";

/**
 * Sourcing Access Redux API
 *
 * Cache invalidation strategy:
 * 1. refetchOnMountOrArgChange: true - Ensures data is refetched when components mount during navigation
 * 2. keepUnusedDataFor: 0 - Immediately invalidates cache when not in use
 * 3. refetchOnFocus: true - Refetches data when window regains focus
 * 4. refetchOnReconnect: true - Refetches data when network reconnects
 * 5. Mutations invalidate relevant tags to trigger refetches
 */

export const sourcingAccessReduxAPI = createApi({
  reducerPath: "sourcingAccessReduxAPI",
  baseQuery: baseQueryWithArgs,
  refetchOnMountOrArgChange: true, // Refetch when component mounts or arguments change
  refetchOnReconnect: true, // Refetch when network reconnects

  tagTypes: ["getSourcingAccessStatus"],

  endpoints: (builder) => ({
    //GET Queries
    getSourcingAccessStatus: builder.query({
      query: () => getQueryStringWithCreator(`s/getSourcingEligibilityStatus`),
      providesTags: ["getSourcingAccessStatus"],
      refetchOnMountOrArgChange: true, // Ensure refetch on component mount or when arguments change
      keepUnusedDataFor: 0, // Don't keep data in cache when not in use (immediate invalidation)
    }),
  }),
});

function showToast({ variant, message }) {
  store.dispatch(showToastNotification({ variant, message }));
  setTimeout(() => {
    store.dispatch(hideToastNotification());
  }, 3000);
}

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetSourcingAccessStatusQuery } = sourcingAccessReduxAPI;
